import React, { useEffect, useMemo, useState } from 'react';
import './index.scss';

// 登录、注册、忘记密码、个人中心编辑等页面也做横屏限制；输入框聚焦时（键盘可能弹起）不判断，避免误判
const isInputFocused = () => {
  const el = document.activeElement;
  if (!el || !el.tagName) return false;
  const tag = el.tagName.toLowerCase();
  return tag === 'input' || tag === 'textarea' || el.isContentEditable;
};

const isMobileDevice = () => {
  const ua = navigator.userAgent || '';
  const uaMobile = /android|iphone|ipad|ipod|mobile/i.test(ua);
  // iPadOS 某些 UA 会伪装成 Mac；用触控点兜底
  const touchLike = (navigator.maxTouchPoints || 0) > 0;
  return uaMobile || touchLike;
};

// 横屏判断：优先用设备方向 API（真实重力/方向），无则用视口比例且加阈值，避免虚拟键盘等导致竖屏被误判为横屏
const isLandscapeNow = () => {
  if (typeof window === 'undefined') return false;
  const type = window.screen?.orientation?.type;
  if (type) {
    return /landscape/i.test(type);
  }
  const w = window.innerWidth;
  const h = window.innerHeight;
  if (h <= 0) return false;
  // 仅当宽明显大于高时才判为横屏（如 1.2 倍），避免键盘收起、平板等导致 width>height 的误判
  const RATIO = 1.2;
  return w > h * RATIO;
};

const OrientationGuard = ({ enabled = true }) => {
  const [landscape, setLandscape] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const isMobile = useMemo(() => isMobileDevice(), []);

  useEffect(() => {
    if (!enabled || !isMobile) return;
    const update = () => setLandscape(isLandscapeNow());
    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, [enabled, isMobile]);

  // 输入框聚焦时（键盘可能弹起）不做横屏判断，避免视口比例变化导致误判
  useEffect(() => {
    if (!enabled || !isMobile) return;
    const onFocusChange = () => setInputFocused(isInputFocused());
    window.addEventListener('focusin', onFocusChange);
    window.addEventListener('focusout', onFocusChange);
    onFocusChange();
    return () => {
      window.removeEventListener('focusin', onFocusChange);
      window.removeEventListener('focusout', onFocusChange);
    };
  }, [enabled, isMobile]);

  if (!enabled || !isMobile || !landscape || inputFocused) return null;

  return (
    <div className="orientation-guard" role="dialog" aria-modal="true">
      <div className="orientation-guard-card">
        <div className="orientation-guard-icon" aria-hidden />
        <div className="orientation-guard-title">请竖屏使用</div>
        <div className="orientation-guard-sub">
          为了更好的闯关体验，我们暂不支持横屏展示。请将手机旋转回竖屏继续。
        </div>
      </div>
    </div>
  );
};

export default OrientationGuard;

